import { render, staticRenderFns } from "./notaTextLayoutDesktop.vue?vue&type=template&id=e75201ca&scoped=true&"
import script from "./notaTextLayoutDesktop.vue?vue&type=script&lang=js&"
export * from "./notaTextLayoutDesktop.vue?vue&type=script&lang=js&"
import style0 from "./notaTextLayoutDesktop.vue?vue&type=style&index=0&id=e75201ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75201ca",
  null
  
)

export default component.exports